import _slicedToArray from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import e from "react";
import { getActorContext as t, translate as r, defaultFormFieldOptions as o, censorPhoneNumber as i, censorAllButFirstAndLast as n } from "@aws-amplify/ui";
import { Flex as a } from "../../../primitives/Flex/Flex.js";
import { Heading as m } from "../../../primitives/Heading/Heading.js";
import { Radio as s } from "../../../primitives/Radio/Radio.js";
import { RadioGroupField as l } from "../../../primitives/RadioGroupField/RadioGroupField.js";
import { useAuthenticator as u } from "../hooks/useAuthenticator/index.js";
import { useCustomComponents as c } from "../hooks/useCustomComponents/index.js";
import { useFormHandlers as d } from "../hooks/useFormHandlers/useFormHandlers.js";
import { RemoteErrorMessage as f } from "../shared/RemoteErrorMessage.js";
import { TwoButtonSubmitFooter as p } from "../shared/TwoButtonSubmitFooter.js";
import { RouteContainer as h } from "../RouteContainer/RouteContainer.js";

var v = function v(e, t) {
  var o = r(e);
  var a = t;
  if ("Phone Number" === e) a = i(t);else if ("Email" === e) {
    var _e = t.split("@");

    a = "".concat(n(_e[0]), "@").concat(_e[1]);
  }
  return "".concat(o, ": ").concat(a);
},
    E = function E(_ref) {
  var i = _ref.className,
      n = _ref.variation;

  var _c = c(),
      _c$components$VerifyU = _c.components.VerifyUser,
      _c$components$VerifyU2 = _c$components$VerifyU.Header,
      m = _c$components$VerifyU2 === void 0 ? E.Header : _c$components$VerifyU2,
      _c$components$VerifyU3 = _c$components$VerifyU.Footer,
      b = _c$components$VerifyU3 === void 0 ? E.Footer : _c$components$VerifyU3,
      _u = u(function (e) {
    return [e.isPending];
  }),
      y = _u._state,
      F = _u.isPending,
      _d = d(),
      j = _d.handleChange,
      g = _d.handleSubmit,
      x = t(y),
      H = F ? e.createElement(e.Fragment, null, "Verifying…") : e.createElement(e.Fragment, null, r("Verify")),
      C = e.createElement(l, {
    label: r("Verify Contact"),
    labelHidden: !0,
    name: "verify_context",
    isDisabled: F
  }, function (t) {
    var r = [];

    for (var _i = 0, _Object$entries = Object.entries(t); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          _i2 = _Object$entries$_i[0],
          _n = _Object$entries$_i[1];

      var _t = e.createElement(s, {
        name: "unverifiedAttr",
        value: _i2,
        key: _i2
      }, v(o[_i2].label, _n));

      r.push(_t);
    }

    return r;
  }(x.unverifiedAttributes));

  return e.createElement(h, {
    className: i,
    variation: n
  }, e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-verifyuser": "",
    method: "post",
    onChange: j,
    onSubmit: g
  }, e.createElement(a, {
    as: "fieldset",
    direction: "column",
    isDisabled: F
  }, e.createElement(m, null), C, e.createElement(f, null), e.createElement(p, {
    cancelButtonText: r("Skip"),
    cancelButtonSendType: "SKIP",
    submitButtonText: H
  }), e.createElement(b, null))));
};

E.Header = function () {
  return e.createElement(m, {
    level: 3
  }, r("Account recovery requires verified contact information"));
}, E.Footer = function () {
  return null;
};
export { E as VerifyUser };